import { Button, ButtonTypeMap } from '@mui/joy';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ButtonHTMLAttributes, FormEvent, PropsWithChildren, ReactElement } from 'react';
import { IOverlayLoaderStore } from '../../modules/common/OverlayLoader.store';

interface IProps extends PropsWithChildren<ButtonTypeMap['props']>, Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'color'> {
  loaderKey?: string;
  // eslint-disable-next-line @typescript-eslint/no-misused-promises
  onClick: (e: FormEvent) => Promise<void> | void;
}

export const ButtonWithLoader = observer((props: IProps): ReactElement => {
  const overlayLoaderStore = useInjection(IOverlayLoaderStore.$);

  const { loading, loaderKey, ...rest } = props;
  const isReallyLoading = (loading || (!!loaderKey && overlayLoaderStore.isSpinnerVisible(props.loaderKey))) ?? false;

  return (
    <Button
      {...rest}
      loading={isReallyLoading}
    >
      {props.children}
    </Button>
  );
});
